import { DroppedFramesHistory, IDroppedFramesHistoryItem } from '@abrController/DataCollectors/DroppedFramesHistory/DroppedFramesHistory';
import { IDroppedFramesEstimatorConfig } from '@abrController/Estimators/DroppedFramesEstimator/DroppedFramesEstimator.config';
import { IEstimator } from '@abrController/Estimators/IEstimator';
import { BufferControllerEvents } from '@bufferController/BufferController.events';
import { IBufferMetrics } from '@bufferController/BufferMetrics/IBufferMetrics';
import { ConfigConsumer } from '@configProvider/ConfigConsumer';
import { EDebuggableModuleState, TDebuggableAdditionalInfo } from '@customTypes/common';
import { TEventBus } from '@eventBus/EventBus';
import { IResolution } from '@resolutionsManager/IResolutionsManager';
import bind from '@utils/decorators/bind';

export class DroppedFramesEstimator extends ConfigConsumer<IDroppedFramesEstimatorConfig> implements IEstimator {
  public state: EDebuggableModuleState = EDebuggableModuleState.OK;
  public status: string = 'Idle';
  public additionalInfo: TDebuggableAdditionalInfo = { droppedFramesByResolution: {} };
  public groups: string[] = ['abr'];

  private _lastClearTs: number = 0;

  private readonly _onMetricsReadyListener: string;
  private readonly _droppedFramesHistory: DroppedFramesHistory = new DroppedFramesHistory(this._eventBus);

  constructor(eventBus: TEventBus) {
    super('droppedFramesEstimator', eventBus);

    this._onMetricsReadyListener = this._eventBus.subscribe(BufferControllerEvents.bufferMetricsAvailable, this._onMetricsReady);
  }

  public destroy(): void {
    super.destroy();

    this._droppedFramesHistory.destroy();

    this._eventBus.unsubscribe(this._onMetricsReadyListener);
  }

  public reset(): void {
    this._droppedFramesHistory.reset();
  }

  public getNextEstimatedResolution(availableDecreasingResolutions: IResolution[]): IResolution | null {
    const { minimalFramesPlayed } = this.config;
    return (
      availableDecreasingResolutions.find(({ name }) => {
        const droppedFrames: IDroppedFramesHistoryItem | null = this._droppedFramesHistory.getResolutionHistoryByName(name);
        this.additionalInfo.droppedFramesByResolution[name] = droppedFrames;
        return (
          !droppedFrames ||
          droppedFrames.totalFramesNumber < minimalFramesPlayed ||
          droppedFrames.droppedFramesNumber / droppedFrames.totalFramesNumber < this.config.optimalDroppedFramesFraction
        );
      }) || null
    );
  }

  public _handleConfigUpdated(): void {}

  @bind
  private _onMetricsReady(metrics: IBufferMetrics): void {
    if (metrics.currentTimestamp - this._lastClearTs > this.config.resetHistoryTimeout) {
      this._droppedFramesHistory.reset();
      this._lastClearTs = metrics.currentTimestamp;
    }
  }
}
